import { render, staticRenderFns } from "./DataTableTask.vue?vue&type=template&id=5af31b0e&"
import script from "./DataTableTask.vue?vue&type=script&lang=js&"
export * from "./DataTableTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports